module.exports = __webpack_public_path__ + "assets/img/2022_08.a22d44fc.png";